/** @format */

import { ToolTipModule } from '@shared/components';
import {
	HmfAccordionComponent,
	HmfActionTextComponent,
	HmfButtonComponent,
	HmfDrawerComponent
} from '@dsg-tech/homefield-angular';
import {
	HomefieldIconLibraryModule,
	homefieldIconListBullet,
	HomefieldIconsLibraryService
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { MediaModule } from '@shared/media/components';
import { NgModule } from '@angular/core';
import { ProductDescriptionComponent } from './product-description.component';
import { ImagesLoadedDirective } from '@shared/utils/directives';

@NgModule({
	declarations: [ProductDescriptionComponent],
	imports: [
		CommonModule,
		HmfAccordionComponent,
		HmfActionTextComponent,
		HmfButtonComponent,
		HmfDrawerComponent,
		HomefieldIconLibraryModule,
		ImagesLoadedDirective,
		MediaModule,
		ToolTipModule
	],
	exports: [ProductDescriptionComponent]
})
export class ProductDescriptionModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconListBullet]);
	}
}
